import React from "react";
import { Link } from "react-router-dom";
import "./research-overview.scss";
import Research from "../../assets/images/research.png";
import Optics from "../../assets/images/optics.jpeg";
import Nuclear from "../../assets/images/nuclear.jpeg";
export const ResearchOverview = () => {
  return (
    <>
      {" "}
      <div className="research-page">
        {" "}
        <center>
          <h1>RESEARCH OVERVIEW</h1>
        </center>
        <div className="flexy flexyM offset-md-5 mt5">
          {" "}
          <Link to={"/"} className="home-link">
            HOME
          </Link>
          <span>
            <i class="icofont-rounded-right"></i>
          </span>
          <h6>Research</h6>
        </div>
      </div>
      <div className="col-md-6 offset-md-2 mtt">
        {" "}
        <p>
          The research strategy of the Department of Physics, University of Port
          Harcourt is focused on <strong>five basic research groups</strong>{" "}
          (TEAMS) under which fall a number of research interest areas as stated
          below and shown in the table.
        </p>
        <ul>
          <li>Applied physics Research Team</li>
          <li>Geophysics Research Team</li>
          <li>Theoretical Physics Research Team</li>
          <li>Science and Condensed Matter Physics Research Team</li>
          <li>Environmental Physics Research Team</li>
        </ul>
      </div>
      <center>
        <div className="col-md-8 mt">
          <Link to={"/"}>
            {" "}
            <img className="" src={Research} alt="Scholar" width="100%" />
          </Link>
        </div>
      </center>
      <div className="col-md-8 offset-md-2 mt5">
        <p>
          Our seven research themes span the full range of research activities
          being carried out in the Laboratory and reflect national research
          priorities. Many themes cover the work of more than one research
          group, encouraging new associations and cross-disciplinary
          collaboration. While the core of our research programme is in
          experimental physics, essential theoretical support is provided by
          theorists embedded within the astrophysics and high energy physics
          research groups, while the condensed matter theory group are strongly
          cross-disciplinary and contribute to most of the themes shown above.
        </p>
        <div className="flexy mt6">
          <div className="col-md-6 research-links flexy flexyM">
            <div className="col-md-5 research-img">
              {" "}
              {/* <img className="" src={Nuclear} alt="Scholar" width="100%" /> */}
            </div>
            <div className="col-md-6 research-detail">
              <h6>Research Groups</h6>
              <Link
                to={"/research-groups"}
                className="offset-md-8 research-arrow"
              >
                <i class="icofont-circled-right"></i>
              </Link>
            </div>
          </div>
          <div className="col-md-6 research-links flexy flexyM">
            <div className="col-md-5 research-img2">
              {" "}
              {/* <img className="" src={Optics} alt="Scholar" width="100%" /> */}
            </div>
            <div className="col-md-6 research-detail">
              <h6>Research Programmes</h6>
              <Link
                to={"/research-programmes"}
                className="offset-md-8 research-arrow"
              >
                <i class="icofont-circled-right"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
